// assetErrors — shared classification for asset-write failures.
//
// The motivating bug: a client's in-memory asset list can point at an
// environment that was deleted or superseded on the server by another session
// (the artist re-uploaded several times). Acting on that stale id — saving a
// pose, deleting — hits a row that no longer exists. The asset-manager wraps
// gorm.ErrRecordNotFound as "record not found" with HTTP 404 in its get-by-id
// path (update/delete). We detect that so callers can re-sync the list and show
// a clear message instead of a raw server string.

export const STALE_ASSET_MESSAGE =
  'This asset no longer exists on the server — it was deleted or replaced in another session. The list has been refreshed; pick it again.'

// True when an error means "the server has no such record" (a stale client
// pointing at a deleted/superseded asset). Kept narrow on purpose: a 404 on a
// write, or the asset-manager's literal "record not found" wording. We do NOT
// match a bare "not found" so unrelated 404s/messages don't get misclassified.
export function isRecordGoneError(err) {
  if (!err) return false
  if (err.status === 404) return true
  return /record not found/i.test(String(err.message ?? err))
}

// True when a PATCH failed due to a version mismatch (If-Match header conflict).
// The server responds 409 with the current row in the response body so the client
// can reconcile (reload or overwrite with the new version).
// Requires status=409, error field='version_conflict', and current row present.
export function isVersionConflict(err) {
  return err?.status === 409 && err?.error === 'version_conflict' && err?.current != null
}
